<template>
  <div class="home-card-box">
    <div class="home-card-title">
      <a class="title-zh" @click="handleClick">{{ titleZh }}</a>&nbsp;|&nbsp;<span>{{ titleEn }}</span>
      <a @click="handleClick">更多>></a>
    </div>
    <div class="home-card-container">
      <slot />
    </div>
  </div>
</template>

<script>
import { getMenuByName, getMenuById } from "@/config/menus"

export default {
  name: "HomeCard",
  props: {
    name: {
      type: String,
      default: ""
    },
    menuId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      titleZh: "",
      titleEn: "",
      menu: null
    }
  },
  mounted() {
    this.menu = this.menuId ? getMenuById(this.menuId) : getMenuByName(this.name)
    if (this.menu) {
      this.titleEn = this.menu.nameEn?.toUpperCase() || ""
    }
    this.titleZh = this.name
  },
  methods: {
    handleClick() {
      if (this.menu) {
        this.$router.push(`/index/lists/${this.menu.id}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-card-box {
  font-size: 16px;
  border: 1px solid #dddddd;
  .home-card-title {
    height: 34px;
    border-bottom: 1px solid #dddddd;
    background: #eee;
    line-height: 34px;
    padding: 0 15px;
    > a:first-child {
      color: #0268b3;
    }
    > a:last-child {
      font-size: 12px;
      color: #fdc202;
      float: right;
    }
    a {
      cursor: pointer;
      text-decoration: none
    }
    a:hover {
      text-decoration: underline
    }
    span {
      font-size: 14px;
      line-height: 38px;
      color: #777777;
    }
  }
  .home-card-container {
    margin: 15px 15px 0 15px;
  }
}
</style>